/*
 * Authors: Koen, mariushirjanu
 * Created: 30/10/2015
 * Created: 31/01/2023
 */
import { PriceCartService } from '../cart/price-cart.service';
import { OrderEntryWebshopService } from '../entry/webshop/order-entry-webshop.service';
import { Injectable } from '@angular/core';
import { HttpDataService } from '../../../shared/http/http-data.service';
import { ICurrency, IObject } from '../../../../type_definitions/datatypes';
import { PunchoutService } from './punchout.service';

interface ICheckoutData {
  bpCompanyCountryId:number;
  punchOutCurrency:string;
  billingType:string;
  products:any;
}

@Injectable()
export class PunchoutDataService {
  constructor(
    private httpDataService:HttpDataService,
    private priceCartService:PriceCartService,
    private punchoutService:PunchoutService,
    private orderEntryWebshopService:OrderEntryWebshopService
  ) {
    /***/
  }

  public checkout(punchoutMessageId?:number):any {
    const webshopId:number = this.orderEntryWebshopService.selectedShop.id;
    const countryId:number = this.orderEntryWebshopService.selectedCountry.id;
    const params:IObject = { punchOutMessageId: punchoutMessageId || this.punchoutService.getPunchoutMessageId() };
    const currency:ICurrency = this.orderEntryWebshopService.shopContext.defaultOrderCurrency;
    const data:ICheckoutData = this.prepareCheckout(this.orderEntryWebshopService.shopContext.bp.location.companyCountry.id, this.orderEntryWebshopService.shopContext.billingType, currency.isoCode, this.priceCartService.preparedCartStatus());

    if (data.products?.length) {
      return this.httpDataService.doPOST(
        `rest/punchout/webshops/${webshopId}/countries/${countryId}/order`,
        params,
        data,
        'Processing order',
        'Error processing order'
      );
    } else {
      return Promise.resolve();
    }
  }

  public prepareCheckout(bpCompanyCountryId:number, billingType:string, currency:string, products):ICheckoutData {
    return {
      bpCompanyCountryId,
      punchOutCurrency: currency,
      billingType,
      products
    };
  }
}